import React, { useEffect, useState } from "react";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from "@material-ui/core";
import { SIREN_CONFIG } from "config.js";
import { FormattedMessage, useIntl } from "react-intl";


/**
 * 낙상이 발생한 해당 이벤트의 좌표값 리스트를 표시
 * @param {*} props 
 * @returns 
 */
export const FallEventsTable = props => {

  const { className, eventId, ...rest } = props;

  const [fallEventTarget, setFallEventTarget] = useState([]);

  async function loadDeviceStatus() {

    var url = `${SIREN_CONFIG.HOSTNAME}/emergency/fallEventTarget?eventId=${eventId}`;
    const opt = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };

    let response = await fetch(url, opt);
    let responseData = await response.json();

    let rows = [];
    await responseData.resultData.map(function (row) {
      rows.push(row);
      console.log(row);
    });

    setFallEventTarget(rows);
  }


  useEffect(() => {
    loadDeviceStatus();
  }, []);


  return (

    <div style={{
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      marginBottom: "40px",
      flexDirection: 'column',
      alignItems: 'space-between', justifyContent: "center"
    }}>

      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell width="20%" align="center"><FormattedMessage id="emergency_target_id" /></TableCell>
            <TableCell width="30%" align="center"><FormattedMessage id="emergency_x_pos" /></TableCell>
            <TableCell width="30%" align="center"><FormattedMessage id="emergency_y_pos" /></TableCell>
            <TableCell width="30%" align="center"><FormattedMessage id="emergency_z_pos" /></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {fallEventTarget.map((row, i) => (
            <TableRow>
              <TableCell width="20%" align="center"><Typography variant="body2">{row.targetId}</Typography> </TableCell>
              <TableCell width="30%" align="center"><Typography variant="body2">{row.xPosCm}</Typography></TableCell>
              <TableCell width="30%" align="center"><Typography variant="body2">{row.yPosCm}</Typography></TableCell>
              <TableCell width="30%" align="center"><Typography variant="body2">{row.zPosCm}</Typography></TableCell>
            </TableRow>
          ))}
        </TableBody>

      </Table>
    </div>
  )
}

